<nav [hidden]="!headerService.withHeader()" class="navbar shadow fixed-top navbar-expand-lg bg-white px-3">
  <div class="d-flex w-100 align-items-center">
    <div class="d-flex flex-row flex-grow-1">
      <div ngbDropdown class="me-4" #appsDropdown="ngbDropdown">
        <button class="btn eh-btn-secondary" id="apps-dropdown" ngbDropdownToggle>
          <i class="fa-regular fa-grid-round" aria-hidden="true"></i>
          <span class="px-2">{{ 'HEADER.APPS' | translate }}</span>
          <div
            ngbDropdownMenu
            class="bg-white border border-gray2 rounded-1 shadow-sm p-0"
            aria-labelledby="apps-dropdown"
          >
            <div class="d-flex flex-column p-3 pb-0 text-center">
              @if (e360UserService.homeModule) {
                <button
                  class="btn eh-btn-tertiary"
                  (click)="appClick.emit(e360UserService.homeModule); appsDropdown.close()"
                >
                  <span>{{ 'HEADER.E360_HOMEPAGE' | translate }}</span>
                  <i class="fa-light fa-chevron-right ms-2" aria-hidden="true"></i>
                </button>
                <hr class="text-teal3 opacity-100" />
              }
              @if (!e360UserService.modulesForCurrentOrg?.length && !e360UserService.modulesForDifferentOrg?.length) {
                <p class="mx-auto">{{ 'HEADER.NO_APPS' | translate }}</p>
              } @else {
                <ng-template #appList let-modules="modules">
                  <div class="d-flex flex-wrap pt-2">
                    @for (m of modules; track $index) {
                      @if (m.name !== HOME_APP_NAME) {
                        <button
                          class="d-flex flex-column justify-content-top mb-3 w-50 app-btn btn eh-btn-tertiary p-0"
                          (click)="appClick.emit(m); appsDropdown.close()"
                        >
                          @if (
                            m.name === ACS_APP_NAME ||
                            m.name === CARE_SCHEDULER_APP_NAME ||
                            m.name === MATCH_APP_NAME ||
                            m.name === OPE_APP_NAME ||
                            m.name === SCHEDULE_APP_NAME ||
                            m.name === SOP_TOOL_APP_NAME ||
                            m.name === VAXREACH_APP_NAME
                          ) {
                            <div class="mx-auto border border-blue5 bg-blue3 rounded-1 app-icon-wrap py-2">
                              <i [classList]="m.iconClasses + ' fs-4' + ' text-gray1'"></i>
                            </div>
                          } @else if (m.name === CENTRAL_PAY_RECON_APP_NAME || m.name === MED_BILL_APP_NAME) {
                            <div class="mx-auto border border-green5 bg-green3 rounded-1 app-icon-wrap py-2">
                              <i [classList]="m.iconClasses + ' fs-4' + ' text-gray1'"></i>
                            </div>
                          } @else if (
                            m.name === MY_DATA_MART_APP_NAME ||
                            m.name === MUTUAL_DRUG_ANALYTICS_APP_NAME ||
                            m.name === PROFIT_AMP_APP_NAME ||
                            m.name === RX_COMPASS_APP_NAME ||
                            m.name === RX_MENTOR_APP_NAME
                          ) {
                            <div class="mx-auto border border-teal5 bg-teal3 rounded-1 app-icon-wrap py-2">
                              <i [classList]="m.iconClasses + ' fs-4' + ' text-gray1'"></i>
                            </div>
                          } @else {
                            <div class="mx-auto border border-teal3 bg-teal1 rounded-1 app-icon-wrap py-2">
                              <i [classList]="m.iconClasses + ' fs-4'"></i>
                            </div>
                          }
                          <p class="mx-auto mb-0 mt-2 text-gray9 text-break">
                            {{ m.displayName }}
                            @if (m.type === 'TOP') {
                              <i container="body" class="mx-1 fa-light fa-up-right-from-square"></i>
                            }
                          </p>
                        </button>
                      }
                    }
                  </div>
                </ng-template>
                @if (e360UserService.modulesForCurrentOrg?.length) {
                  <ng-container
                    [ngTemplateOutlet]="appList"
                    [ngTemplateOutletContext]="{
                      modules: e360UserService.modulesForCurrentOrg
                    }"
                  ></ng-container>
                }
                @if (e360UserService.modulesForDifferentOrg?.length) {
                  <div class="d-flex align-items-center">
                    <p class="m-0">
                      {{ (!e360UserService.isGlobalUser ? 'APPS_REQUIRE_AUTH' : 'APPS_FOR_SELECTED_ORG') | translate }}
                    </p>
                    <i
                      [ngbTooltip]="
                        (!e360UserService.isGlobalUser ? 'AUTH_TOOLTIP' : 'APPS_SELECTED_ORG_TOOLTIP') | translate
                      "
                      container="body"
                      class="ms-2 fa-light fa-circle-info text-teal7"
                      aria-hidden="true"
                    ></i>
                  </div>
                  <hr class="text-teal3 mt-2 mb-3 opacity-100" />
                  <ng-container
                    [ngTemplateOutlet]="appList"
                    [ngTemplateOutletContext]="{
                      modules: e360UserService.modulesForDifferentOrg
                    }"
                  ></ng-container>
                }
              }
            </div>
          </div>
        </button>
      </div>
      <img
        (click)="appClick.emit(e360UserService.homeModule)"
        (keydown.enter)="appClick.emit(e360UserService.homeModule)"
        role="link"
        tabindex="0"
        src="./assets/images/e360-logo.svg"
        alt="E360 logo"
      />
    </div>
    @if (headerService.withOrgSelector()) {
      <div id="org-selector" class="d-flex align-items-center" [class.me-5]="headerService.withOrgStoreSelector()">
        <label class="me-3 text-gray9 fw-normal" for="organization-dropdown">
          {{ 'HEADER.ORGANIZATION' | translate }}
        </label>
        <ng-select
          #orgSelector
          [disabled]="headerService.disableOrgSelector()"
          name="organization-dropdown"
          class="eh-ngselect"
          labelForId="organization-dropdown"
          bindLabel="name"
          [clearable]="false"
          [items]="stateService.orgs"
          [(ngModel)]="stateService.selectedOrg"
          (ngModelChange)="orgChanged($event)"
          [typeahead]="orgSearch$"
          [loading]="orgsLoading"
          (scrollToEnd)="onOrgScrollToEnd()"
          placeholder="{{ 'HEADER.PLEASE_SELECT' | translate }}"
        ></ng-select>
      </div>
    }
    @if (headerService.withOrgStoreSelector()) {
      <div id="org-store-selector" class="d-flex align-items-center">
        <label class="me-3 text-gray9 fw-normal" for="org-stores-dropdown">{{ 'HEADER.STORE' | translate }}</label>
        <ng-select
          #orgStoreSelector
          [disabled]="headerService.disableOrgStoreSelector()"
          name="org-stores-dropdown"
          labelForId="org-stores-dropdown"
          class="eh-ngselect"
          bindLabel="name"
          [clearable]="false"
          [items]="stateService.orgStores"
          [(ngModel)]="stateService.selectedOrgStore"
          (ngModelChange)="orgStoreChanged()"
          placeholder="{{ 'HEADER.PLEASE_SELECT' | translate }}"
        ></ng-select>
      </div>
    }
  </div>
</nav>
